<template>
  <v-container>
    <!-- ตารางผลตรวจอื่นๆ (Other) 1 -->
    <!-- <div class="align-center pt-2">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >ผลตรวจอื่นๆ (Other)</span
      >
    </div>
    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers_other"
      :items="other"
      :hide-default-footer="true"
    >
      <template v-slot:item.checklist="props">
        <v-text-field
          v-model="props.item.checklist"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุค่าปกติ"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field
      ></template>
      <template v-slot:item.results="props">
        <v-text-field
          v-model="props.item.results"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุผลตรวจ"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field
      ></template>
      <template v-slot:item.normal="props">
        <v-text-field
          v-model="props.item.normal"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุค่าปกติ"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field
      ></template>
      <template v-slot:item.summary="props">
        <v-text-field
          v-model="props.item.summary"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุผลการสรุป"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field
      ></template>
    </v-data-table> -->
    <!-- ----------------- -->
    <!-- <div style="margin-top: 30px"></div> -->
    <!-- ผลตรวจอื่นๆ 2 -->
    <div class="align-center mt-3 pt-2">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >ผลตรวจอื่นๆ</span
      >
    </div>
    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers_other2"
      :items="other2"
      :hide-default-footer="true"
    >
      <template v-slot:item.checklist> สมรรถภาพแขนและมือ</template>
      <template v-slot:item.results>
        <v-text-field
          v-model="other2[0].performance.armAndHand.results"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุผลตรวจ"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field
      ></template>
      <template v-slot:item.normal> (เกณฑ์เพศและอายุ) </template>
      <template v-slot:item.summary>
        <v-text-field
          v-model="other2[0].performance.armAndHand.summary"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุผลการสรุป"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-text-field
      ></template>
      <template v-slot:body.append>
        <tr>
          <td class="text-center">สมรรถภาพหลังและขา</td>
          <td>
            <v-text-field
              v-model="other2[0].performance.backAndlegs.results"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลตรวจ"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
          <td class="text-center">(เกณฑ์เพศและอายุ)</td>
          <td>
            <v-text-field
              v-model="other2[0].performance.backAndlegs.summary"
              flat
              solo
              dense
              hide-details
              placeholder="ระบุผลการสรุป"
              class="ma-2 textfield-sty"
              color="#00A99D"
            ></v-text-field>
          </td>
        </tr>
      </template>
    </v-data-table>
    <!-- ----------------- -->
    <div style="margin-top: 30px"></div>
    <!-- Stool Exam -->
    <div class="align-center mt-3 pt-3">
      <span
        class="pl-2"
        style="font-size: 20px; font-weight: bold; color: #00a99d"
        >การตรวจอุจจาระ (STOOL ANALYSIS)</span
      >
    </div>
    <!-- <v-data-table
      class="elevation-1 my-table-stool mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers_stoolExam"
      :items="stool_Exam"
      :hide-default-footer="true"
    >
      <template v-slot:item.stoolExam="props">
        <v-textarea
          v-model="props.item.stoolExam"
          flat
          solo
          dense
          hide-details
          placeholder="ระบุค่าผลตรวจ"
          class="ma-2 textfield-sty"
          color="#00A99D"
        ></v-textarea
      ></template>
    </v-data-table> -->
    <v-data-table
      class="elevation-1 my-table mt-4 ml-1"
      style="background-color: #f6f6f6"
      :headers="headers_stoolExam"
      :items="stool_Exam"
      :hide-default-footer="true"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr>
            <td>{{ items[0].text }}</td>
            <td>
              <v-text-field
                v-model="items[0].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
            <td>{{ items[0].normal }}</td>
          </tr>

          <tr>
            <td>{{ items[1].text }}</td>
            <td>
              <v-text-field
                v-model="items[1].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
            <td>{{ items[1].normal }}</td>
          </tr>

          <tr>
            <td>{{ items[2].text }}</td>
            <td>
              <v-text-field
                v-model="items[2].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
                type="number"
              ></v-text-field>
            </td>
            <td>{{ items[2].normal }}</td>
          </tr>

          <tr>
            <td>{{ items[3].text }}</td>
            <td>
              <v-text-field
                v-model="items[3].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
                type="number"
              ></v-text-field>
            </td>
            <td>{{ items[3].normal }}</td>
          </tr>

          <tr>
            <td>{{ items[4].text }}</td>
            <td>
              <v-text-field
                v-model="items[4].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
            <td>{{ items[4].normal }}</td>
          </tr>

          <tr>
            <td style="align-content: baseline;">{{ items[5].text }}</td>
            <td 
              colspan="2" 
              style="align-content: baseline;"
            >
              <v-textarea
                v-model="items[5].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-textarea>
            </td>
            <!-- <td>{{ items[5].normal }}</td> -->
          </tr>

          <tr>
            <td colspan="3" style="background-color: #f2fcf5">
              <span class="text-00A99D">ผลตรวจการเพาะเชื้ออุจจาระ (other)</span>
            </td>
          </tr>

          <tr>
            <td>{{ items[6].text }}</td>
            <td>
              <v-text-field
                v-model="items[6].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
            <td>{{ items[6].normal }}</td>
          </tr>

          <tr>
            <td>{{ items[7].text }}</td>
            <td>
              <v-text-field
                v-model="items[7].value"
                flat
                solo
                dense
                hide-details
                placeholder="ระบุผลตรวจ"
                class="ma-2 textfield-sty"
                color="#00A99D"
              ></v-text-field>
            </td>
            <td>{{ items[7].normal }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { EventBus } from "../../EventBus";
export default {
  data() {
    return {
      headers_other: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "checklist",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "results",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "normal",
        },
        {
          text: "สรุปผล",
          align: "center",
          sortable: false,
          value: "summary",
        },
      ],
      headers_other2: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "checklist",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "results",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "normal",
        },
        {
          text: "สรุปผล",
          align: "center",
          sortable: false,
          value: "summary",
        },
      ],
      headers_stoolExam: [
        {
          text: "รายการตรวจ",
          align: "center",
          sortable: false,
          value: "stoolExam",
        },
        {
          text: "ผลตรวจ",
          align: "center",
          sortable: false,
          value: "stoolResult",
        },
        {
          text: "ค่าปกติ",
          align: "center",
          sortable: false,
          value: "stoolNormal",
        },
      ],
      other: [
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
      ],
      other2: [
        {
          performance: {
            armAndHand: {
              results: "",
              summary: "",
            },
            backAndlegs: {
              results: "",
              summary: "",
            },
          },
        },
      ],
      stool_Exam: [
        {
          text: "Color (สีของอุจจาระ)",
          value: "",
          normal: ""
        },
        {
          text: "ลักษณะทั่วไป (Appearance)",
          value: "",
          normal: ""
        },
        {
          text: "เม็ดเลือดแดง",
          value: "",
          normal: "0-5 HPF"
        },
        {
          text: "เม็ดเลือดขาว",
          value: "",
          normal: "0-5 HPF"
        },
        {
          text: "พยาธิ,ไข่พยาธิ",
          value: "",
          normal: "Not Found"
        },
        {
          text: "Stool Exam",
          value: "",
          normal: ""
        },
        {
          text: "Stool Culture",
          value: "",
          normal: ""
        },
        {
          text: "Occult Blood",
          value: "",
          normal: "Negative"
        },
      ],
    };
  },
  created() {
    this.detailAll();
  },
  methods: {
    detailAll() {
      EventBus.$on("detailAll_GetOneForm", (item) => {
        if (item !== undefined && item !== null) {
          this.other = item.treatmentEtc.other || this.other;
          this.other2[0].performance = item.treatmentEtc.performance;
          this.stool_Exam[0].value = item.treatmentEtc.stool.color;
          this.stool_Exam[1].value = item.treatmentEtc.stool.anatomy;
          this.stool_Exam[2].value = item.treatmentEtc.stool.rbc_cell;
          this.stool_Exam[3].value = item.treatmentEtc.stool.wbc_cell;
          this.stool_Exam[4].value = item.treatmentEtc.stool.parasites;
          this.stool_Exam[5].value = item.treatmentEtc.stoolExam;
          this.stool_Exam[6].value = item.treatmentEtc.stool.stool_culture;
          this.stool_Exam[7].value = item.treatmentEtc.stool.occuolt_blood;
        } else {
          this.clear();
        }
      });
    },
    clear() {
      this.other = [
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
        {
          checklist: "",
          results: "",
          normal: "",
          summary: "",
        },
      ];
      // ----------------------
      this.other2[0] = [
        {
          performance: {
            armAndHand: {
              results: "",
              summary: "",
            },
            backAndlegs: {
              results: "",
              summary: "",
            },
          },
        },
      ];
      // ----------------------
      this.stool_Exam[0].stoolExam = "";
      // ----------------------
    },
  },
  beforeDestroy() {
    EventBus.$off("detailAll_GetOneForm", this.detailPhysicalExam);
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.my-table thead th {
  background: #00a99d !important;
  color: #ffffff !important;
  &:first-child {
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 0 10px 0 0;
  }
}
.my-table-stool thead th {
  background: #00a99d !important;
  color: #ffffff !important;
  &:first-child {
    border-radius: 10px 0 0 0;
  }
  &:last-child {
    border-radius: 10px 10px 0 0;
  }
}
.textfield-sty {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.v-data-table-header th {
  font-size: 15px !important;
  font-weight: 500 !important;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button, 
::v-deep input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
    -moz-appearance: textfield;
}
</style>
